export default "__VITE_ASSET__sgevQHA$9rrkn3nu49HsPg__"